<template>
  <cg-alert v-bind="toastItem">
    <template v-if="html">
      <div v-html="toastItem.message" />
    </template>

    <template v-else>
      {{ toastItem.message }}
    </template>
  </cg-alert>   
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { ToastItem } from './types';
// @ts-ignore
import { CgAlert } from '../../components/CgAlert'

export default Vue.extend({
  name: 'CgToastContainerItem',
  // @ts-ignore
  components: { CgAlert },
  props: {
    toastItem: {
      type: Object as PropType<ToastItem>,
      required: true,
    },
    timeout: {
      type: Number,
      required: true
    },
    html: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    itemId (): string | number {
      // @ts-ignore
      return this.toastItem?.id;
    },
    itemTimeout (): number {
      // @ts-ignore
      const { timeout, toastItem } = this
      // @ts-ignore
      return toastItem?.timeout || timeout;
    },
  },
  mounted(): void {
    // @ts-ignore
    setTimeout(() => { this.$emit('dismiss', this.itemId) }, this.itemTimeout)
  },
});
</script>
